import React from "react";

export const unityLoadingValue = (
  setLoadingValue: React.Dispatch<React.SetStateAction<any>>
) => {
  (window as { [key: string]: any })["load_value"] = (value: any) => {
    setLoadingValue(value);
  };
};
